import {
  InfiniteListBase,
  useListContext,
  useTranslate,
  useRedirect,
} from "ra-core";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { MobileListHeader } from "../../layout/MobileListHeader";
import { MobileContent } from "../../layout/MobileContent";
import { InfinitePagination } from "../../misc/InfinitePagination";
import { TransactionDirectionBadge } from "../shared/TransactionDirectionBadge";
import type { Transaction } from "../../types";

export const MobileTransactionList = () => (
  <InfiniteListBase
    perPage={50}
    sort={{ field: "occurred_at", order: "DESC" }}
  >
    <MobileTransactionListLayout />
  </InfiniteListBase>
);

const MobileTransactionListLayout = () => {
  const translate = useTranslate();
  const redirect = useRedirect();
  const { data, isPending, error } = useListContext<Transaction>();

  return (
    <>
      <MobileListHeader
        title={translate("resources.transactions.name", { smart_count: 2 })}
        onCreateClick={() => redirect("create", "transactions")}
      />
      <MobileContent>
        {isPending ? (
          <div className="space-y-3">
            {Array.from({ length: 5 }).map((_, i) => (
              <Skeleton key={i} className="h-16 w-full rounded-xl" />
            ))}
          </div>
        ) : error ? (
          <p className="text-sm text-destructive">
            {translate("ra.message.error")}
          </p>
        ) : data?.length ? (
          <div className="space-y-3">
            {data.map((tx) => (
              <Card
                key={tx.id}
                className="py-3 cursor-pointer active:opacity-70"
                onClick={() => redirect("show", "transactions", tx.id)}
              >
                <CardContent className="px-4 space-y-1">
                  <div className="flex items-start justify-between gap-2">
                    <span className="font-semibold">
                      {Number(tx.amount).toLocaleString("ru-RU")} ₽
                    </span>
                    <TransactionDirectionBadge
                      direction={tx.direction}
                      isTransfer={!!tx.transfer_id}
                    />
                  </div>
                  <div className="text-xs text-muted-foreground">
                    {new Date(tx.occurred_at).toLocaleDateString("ru-RU")}
                  </div>
                  {tx.description && (
                    <p className="text-xs text-muted-foreground line-clamp-1">
                      {tx.description}
                    </p>
                  )}
                </CardContent>
              </Card>
            ))}
          </div>
        ) : (
          <p className="py-16 text-center text-muted-foreground">
            {translate("resources.transactions.empty.title", {
              _: "Транзакций нет",
            })}
          </p>
        )}
        <div className="flex justify-center mt-4">
          <InfinitePagination />
        </div>
      </MobileContent>
    </>
  );
};
